<template>
    <sidebar-layout :moduleCode="moduleCode">

        <template v-slot:aside-main-menu>
            <gestao-menu :moduleCode="moduleCode"></gestao-menu>
        </template>

        <template v-slot:main>
            <div :class="moduleCode + '-page'">
                <slot></slot>
            </div>
        </template>

    </sidebar-layout>
</template>


<script>
import GestaoMenu from '@/app/shared/components/menu/GestaoMenu.vue';
import ModuleMixin from '../shared/mixins/ModuleMixin';

export default {
    mixins: [
        ModuleMixin
    ],
    components: {
        GestaoMenu,
    },
}
</script>

